<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M42.457 10.0664C41.8804 10.0664 41.2997 10.2851 40.8591 10.7266L17.4422 34.1892C16.5609 35.0723 16.5609 36.5083 17.4422 37.3872L28.6729 48.6398C29.5543 49.5229 30.9874 49.5229 31.8646 48.6398L55.2814 25.1772C56.1628 24.2942 56.1628 22.8582 55.2814 21.9793L44.0508 10.7266C43.6101 10.2851 43.0335 10.0664 42.4528 10.0664H42.457Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path
			d="M32.7391 42H28.5484C28.2832 42 28.026 41.8955 27.8372 41.7067L24.2933 38.1634C24.1045 37.9746 24 37.7215 24 37.4524V33.439C24 33.1739 24.1045 32.9168 24.2933 32.7279L39.7305 17.2933C39.9193 17.1045 40.1724 17 40.4416 17H44.6204C44.8856 17 45.1427 17.1045 45.3316 17.2933L48.7067 20.6678C48.8955 20.8567 49 21.1098 49 21.3789V25.7337C49 25.9989 48.8955 26.256 48.7067 26.4448L33.4423 41.7067C33.2535 41.8955 33.0003 42 32.7311 42H32.7391Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path
			d="M36.5027 27C35.8625 27 35.2222 27.2434 34.7302 27.7302C33.7566 28.7037 33.7566 30.2963 34.7302 31.2698C35.7037 32.2434 37.2963 32.2434 38.2698 31.2698C39.2434 30.2963 39.2434 28.7037 38.2698 27.7302C37.7831 27.2434 37.1429 27 36.4974 27H36.5027Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path d="M14.402 39.9668H3.03125" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M14.402 29H3.03125" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M24.3707 19H13" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 60,
		height: 60,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
